import { pathValue as $value, atom as $atom } from '@graphistry/falcor-json-graph';
import { Observable } from '@reactivex/rxjs';
import {
    UPDATE_COLLECTION_SETS,
    UPDATE_COLLECTION_NODE_ENCODING,
    UPDATE_COLLECTION_EDGE_ENCODING,
    TOGGLE_COLLECTIONS_PANEL
} from '@graphistry/viz/src/actions/collections';

const getViewModel = (falcor) =>
    falcor._clone({
      _path: falcor.getPath().slice(0, 4),
    });

export function collections(action$, store) {
    return Observable.merge(
        updateCollectionsSets(action$, store),
        updateCollectionsColorNode(action$, store),
        updateCollectionsColorEdge(action$, store),
        toggleCollectionsVisibility(action$, store),
    ).ignoreElements();
}

function updateCollectionsSets(action$) {
    return action$
        .ofType(UPDATE_COLLECTION_SETS)
        .switchMap(({ falcor, value, fromView }) => {
            return falcor.set(
                $value(
                   fromView ? 'collections.sets' : 'sets' ,
                    $atom(value)
                )
            );
        });
}

function updateCollectionsColorNode(action$) {
    return action$
        .ofType(UPDATE_COLLECTION_NODE_ENCODING)
        .switchMap(({ falcor, index, value }) => {
            if(value === null) {
                return falcor.set(
                    $value(
                        `sets[${index}].node_encoding.type`,
                        'passthrough'
                    )
                );
            }
            return falcor.set(
                $value(
                    `sets[${index}].node_encoding.type`,
                    'fill'
                ),
                $value(
                    `sets[${index}].node_encoding.color`,
                    value
                ),
            );
        });
}

function updateCollectionsColorEdge(action$) {
    return action$
        .ofType(UPDATE_COLLECTION_EDGE_ENCODING)
        .switchMap(({ falcor, index, value }) => {
            if(value === null) {
                return falcor.set(
                    $value(
                        `sets[${index}].edge_encoding.type`,
                        'passthrough'
                    )
                );
            }
            return falcor.set(
                $value(
                    `sets[${index}].edge_encoding.type`,
                    'fill'
                ),
                $value(
                    `sets[${index}].edge_encoding.color`,
                    value
                ),
            );
        });
}

function toggleCollectionsVisibility(action$) {
    return action$
        .ofType(TOGGLE_COLLECTIONS_PANEL)
        .switchMap(({ falcor, value }) => {
            const viewModel = getViewModel(falcor);
            return viewModel.set(
                $value(
                    'collections.visible',
                    value
                )
            );
        });
}